export default __webpack_public_path__ + "static/media/stikers-oval-logo-blue-white.548ea0f7.pdf";